import Axios from 'axios'

const axios = Axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    'Access-Control-Allow-Origin': `${process.env.VUE_APP_API_URL}/api`,
    'access-control-allow-headers': 'Authorization',
  },
})

const getAllRoles = async () => {
  return axios.request({
    method: 'GET',
    url: '/api/roles',
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

const updateRole = async ({ id, ...data }) => {
  return axios.request({
    method: 'patch',
    url: `/api/roles/${id}`,
    data: { id: id, ...data },
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

const saveRole = async (data: Record<string, string>) => {
  return axios.request({
    method: 'POST',
    url: '/api/roles',
    data,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

const deleteRole = async id => {
  return axios.request({
    method: 'DELETE',
    url: `/api/roles/${id}`,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

export default {
  getAllRoles,
  saveRole,
  updateRole,
  deleteRole,
}
